import { render, staticRenderFns } from "./modelExamScoreQueryListInfo.vue?vue&type=template&id=49bc6f3c&scoped=true"
import script from "./modelExamScoreQueryListInfo.vue?vue&type=script&lang=js"
export * from "./modelExamScoreQueryListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc6f3c",
  null
  
)

export default component.exports